import type { ActivityEntityConfig, RawActivity } from "./types";

export type ChecklistActivityType =
  | "summary"
  | "search"
  | "completion"
  | "failure"
  | "update";

export const checklistActivityConfig: ActivityEntityConfig<ChecklistActivityType> =
  {
    eventTypeCategories: {
      completion: "status",
      summary: "system",
      search: "content",
      failure: "system",
      update: "content",
    },
    defaultCategory: "content",
    eventTypeLabels: {
      completion: (raw: RawActivity<ChecklistActivityType>) => {
        const itemDescription = raw.metadata?.itemDescription ?? "item";
        const itemSection = raw.metadata?.itemSection;
        const section = itemSection ? ` (${itemSection})` : "";
        const isCompleted = raw.metadata?.isCompleted;
        if (isCompleted === false) {
          return `Marked incomplete: ${itemDescription}${section}`;
        }
        return `Completed: ${itemDescription}${section}`;
      },
      summary: (raw: RawActivity<ChecklistActivityType>) => {
        const itemDescription = raw.metadata?.itemDescription ?? "item";
        return `AI summary generated for: ${itemDescription}`;
      },
      search: (raw: RawActivity<ChecklistActivityType>) => {
        const docsFound = raw.metadata?.docsFound ?? 0;
        const itemDescription = raw.metadata?.itemDescription ?? "item";
        return `Found ${docsFound} document(s) related to: ${itemDescription}`;
      },
      failure: (raw: RawActivity<ChecklistActivityType>) => {
        const itemDescription = raw.metadata?.itemDescription ?? "item";
        const reason = raw.metadata?.reason ?? "Unknown error";
        return `Failed to generate summary for ${itemDescription}: ${reason}`;
      },
      update: "Item updated",
    },
    fieldLabels: {},
    fieldTitleLabels: {},
    metadataSkipKeys: new Set([
      "changes",
      "success",
      "data",
      "error",
      "requestId",
      "itemDescription",
      "itemSection",
      "docsFound",
      "reason",
      "errorCode",
      "isCompleted",
    ]),
    systemActorName: "System",
  };
